import React from 'react';
import { Box, Typography } from '@mui/material';

export default function ExternalProductSection() {
  return (
    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', py: { xs: 5, md: 10 }, bgcolor: '#fff' }}>
      <Box sx={{ width: '100%', maxWidth: 1600, px: { xs: 2, md: 4 } }}>
        <Typography component="h2" sx={{ fontSize: { xs: 24, md: 36, lg: 55 }, fontWeight: 300, mb: 4, color: '#222', lineHeight: 1.2 }}>
          Is an <Box component="span" sx={{ fontWeight: 500, display: 'inline' }}>external product enough</Box> to <Box component="span" sx={{ fontWeight: 500, display: 'inline' }}>heal acne?</Box>
        </Typography>
        <Typography sx={{ fontSize: { xs: 17, md: 22, lg: 39 }, color: '#222', mb: 3, fontWeight: 300, lineHeight: 1.35 }}>
          For many, yes. With regular use, our Anti-Acne Face Mask—combined with a balanced lifestyle—is often enough to clear and maintain healthy skin.
        </Typography>
        <Typography sx={{ fontSize: { xs: 17, md: 22, lg: 39 }, color: '#222', mb: 3, fontWeight: 300, lineHeight: 1.35 }}>
          But since acne can sometimes be triggered by deeper factors like diet, stress, or hormonal imbalance, we offer personalised Ayurvedic consultations, lifestyle guidance, and internal herbal support when needed.
        </Typography>
        <Typography sx={{ fontSize: { xs: 17, md: 22, lg: 39 }, color: '#222', fontWeight: 300, lineHeight: 1.35 }}>
          The mask remains central to the routine. For some, it works beautifully on its own. For others, it works best alongside a more holistic approach.
        </Typography>
      </Box>
    </Box>
  );
}

